import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { IMusic } from "../../commonTypes";
import { useAudioPlayer } from "../../hooks/useAudioPlayer";
import PlayerCard from "../PlayerCard/PlayerCard";
import RangeProgressBar from "../RangeProgressBar/RangeProgressBar";
import { useGlobalPlayer } from "../../../context/GlobalPlayerProvider";
import { getPreviewSrc } from "../../../helpers/musicHelper";

const ProgressBarWrapper = styled.div`
  position: absolute;
  left: 16px;
  bottom: 16px;
  right: 16px;
  padding: 16px;
  background: rgba(18, 18, 18, 0.4);
  backdrop-filter: blur(40px);
  border-radius: ${({ theme }) => theme.borderRadius.sm};
`;

interface IProps {
  music: IMusic;
  coverResizeWidth?: number;
  className?: string;
}

const LocalPlayerCard = ({ music, coverResizeWidth, className }: IProps) => {
  const audioPlayer = useRef<HTMLAudioElement | null>(null);

  const { pause: pauseGlobalPlayer, isPlaying: isGlobalPlayerPlaying } =
    useGlobalPlayer();

  const {
    duration,
    playProgress,
    isPlaying,
    togglePlay,
    onTimeUpdate,
    onProgressChange,
    onEnded,
    onDurationChange,
  } = useAudioPlayer(audioPlayer);

  const isAudioStarted = isPlaying || playProgress !== 0;

  useEffect(() => {
    if (isPlaying && isGlobalPlayerPlaying) {
      pauseGlobalPlayer();
    }
  }, [isPlaying, isGlobalPlayerPlaying]);

  return (
    <>
      <PlayerCard
        isPlaying={isPlaying}
        togglePlay={togglePlay}
        music={music}
        coverResizeWidth={coverResizeWidth}
        className={className}
      >
        {isAudioStarted && (
          <ProgressBarWrapper onClick={(event) => event.stopPropagation()}>
            <RangeProgressBar
              progress={playProgress}
              onProgressChange={onProgressChange}
              min={0}
              max={duration}
              step={0.1}
            />
          </ProgressBarWrapper>
        )}
      </PlayerCard>
      <audio
        style={{ display: "none" }}
        ref={audioPlayer}
        src={getPreviewSrc(music)}
        onTimeUpdate={onTimeUpdate}
        onEnded={onEnded}
        onDurationChange={onDurationChange}
      />
    </>
  );
};

export default LocalPlayerCard;
